import React, { useState, useEffect, memo } from 'react';

import { withApollo } from 'react-apollo';
import { searchMyCommunitiesQuery } from 'shared/graphql/queries/search/searchMyCommunities';
import AsyncSelect from 'react-select/async';


const SelectGroup = (props) => {
  const [group, setGroup] = useState();
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    (async () => {
      props.client
        .query({
          query: searchMyCommunitiesQuery,
          variables: {
            // queryString: query,
            type: 'MY_COMMUNITIES',
            userId: props.currentUser.id,
          },
        })
        .then(({ data: { search } }) => {
          if (
            !search ||
            !search.searchResultsConnection ||
            search.searchResultsConnection.edges.length === 0
          ) {
            return Promise.resolve([]);
          }
          const communities = search.searchResultsConnection.edges.map(
            c => c.node
          );
          setGroups(
            communities.map(u => ({
              label: u.name,
              value: u.id,
            }))
          );
          // setGroups(communities.map(c => ({ value: c.id, name: c.name })))
          // resolve(communities.map(c => ({ value: c.id, name: c.name })));
        });
    })();
  }, []);
  const onChange = v => {
    props.chooseGroup(v);
    setGroup(v);
  };

  const filterOptions = communities => {
    const results = communities.map(u => ({
      label: u.name,
      value: u.id,
    }));
    return results;
  };
  const loadOptions = inputValue => {
    return new Promise(resolve => {
      setTimeout(() => {
        props.client
          .query({
            query: searchMyCommunitiesQuery,
            variables: {
              queryString: inputValue,
              type: 'MY_COMMUNITIES',
              userId: props.currentUser.id,
            },
          })
          .then(({ data: { search } }) => {
            if (
              !search ||
              !search.searchResultsConnection ||
              search.searchResultsConnection.edges.length === 0
            ) {
              return resolve([]);
            }
            const communities = search.searchResultsConnection.edges.map(
              c => c.node
            );
            // setGroups(communities.map(c => ({ value: c.id, name: c.name })))
            resolve(filterOptions(communities));
          });
      }, 2000);
    });
  };
  return (
    <React.Fragment>
      <AsyncSelect
        cacheOptions
        loadOptions={loadOptions}
        defaultOptions={groups}
        onChange={onChange}
        value={group ? group : props.selectGroup}
      />
    </React.Fragment>
  );
};

export default memo(withApollo(SelectGroup));
